// @flow
import { assign } from 'lodash';
import { connect } from 'react-redux';
import {
    deleteGetAndStoreGrids,
    addGetAndStoreGrids,
    addFilterAndGetAndStoreGrids,
    deleteFilterAndGetAndStoreGrids,
    editFilterAndGetAndStoreGrids
} from '../modules/actions';
import Grid from '../components/pages/Grid';

function mapStateToProps(state: State) {
    return {
        gridsExist: state.grids.length > 0,
        user: state.user
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onDeleteGrid: (gridId, clientId) => {
            dispatch(deleteGetAndStoreGrids(gridId, clientId)).catch(err => console.error(err));
            ownProps.history.replace(assign({}, ownProps.location, { pathname: '/grids' }));
            return Promise.resolve();
        },
        onAddGrid: (clientId, sprocId, name) => {
            return dispatch(addGetAndStoreGrids(clientId, sprocId, name))
                .then(newGridId =>
                    ownProps.history.replace(
                        assign({}, ownProps.location, { pathname: `/grids/${newGridId}` })
                    )
                )
                .catch(err => console.error(err));
        },
        onAddFilter: (gridId, filters, name, clientId) => {
            return dispatch(addFilterAndGetAndStoreGrids(gridId, filters, name, clientId))
                .then(newFilterId =>
                    ownProps.history.replace(
                        assign({}, ownProps.location, {
                            pathname: `/grids/${gridId}/${newFilterId}/edit`
                        })
                    )
                )
                .catch(err => console.error(err));
        },
        onDeleteFilter: (gridId, filterId, clientId) => {
            ownProps.history.replace(
                assign({}, ownProps.location, {
                    pathname: `/grids/${gridId}`
                })
            );
            dispatch(deleteFilterAndGetAndStoreGrids(filterId, clientId)).catch.catch(err =>
                console.error(err)
            );
            return Promise.resolve();
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Grid);



// WEBPACK FOOTER //
// ./containers/GridContainer.jsx